import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import './assets/css/main.css'
import App from './App.vue'
import routes, { setupRouterGuards } from './router'
import { useAuthStore } from './stores/auth'
import i18n from './i18n'
import { appEvents } from './services/appEvents'
import { auctionSocketService } from './services/auctionSocket'
import { userNotificationSocketService } from './services/userNotificationSocket'

const app = createApp(App)

// i18n (locale from localStorage or browser, persisted on change)
app.use(i18n)

// Pinia store
const pinia = createPinia()
app.use(pinia)

// Initialize auth from localStorage before router guards
const authStore = useAuthStore()
authStore.initializeAuth()
if (import.meta.env.VITE_IS_RELEASE_VERSION !== 'true') { // [SOCKET_CONTROL]: Hidden for release
  auctionSocketService.setToken(authStore.token)
  userNotificationSocketService.setToken(authStore.token)
}

// Vue Router
const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Setup router guards
setupRouterGuards(router)

app.use(router)

// Router-aware redirect for unauthorized events (no hard refresh)
appEvents.on('auth:unauthorized', () => {
  const redirect = router.currentRoute.value?.fullPath || '/'
  if (router.currentRoute.value?.name !== 'Auth') {
    router.push({ name: 'Auth', query: { redirect } }).catch(() => {})
  }
})

// Keep auction socket in sync with auth token
watch(
  () => authStore.token,
  (token) => {
    if (import.meta.env.VITE_IS_RELEASE_VERSION !== 'true') { // [SOCKET_CONTROL]: Hidden for release
      auctionSocketService.setToken(token)
      userNotificationSocketService.setToken(token)
    }
  }
)

// Set initial document lang for i18n (LanguageSwitcher updates it on change)
if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.global.locale.value
}

// Toast notifications
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
})

app.mount('#app')




